import { IonFab, IonFabButton, IonIcon, IonItem, IonLabel, IonList } from "@ionic/react";
import { add, pencilOutline } from "ionicons/icons";
import { Link } from "react-router-dom";
import { DataLoadingWardenForQuery } from "../../components/DataLoadingWardenForQuery";
import { useDeleteIngredientCategoryMutation, useGetIngredientCategoriesQuery } from "../../store/data/ingredientCategoriesSlice";
import { ActionWithConfirmation } from "../../components/ActionWithConfirmation";
import { RedirectActionButton } from "../../components/previews/RedirectActionButton";

class ContainerProps {}

export const IngredientCategoryList: React.FC<ContainerProps> = () => {
    const ingredientCategories = useGetIngredientCategoriesQuery("empty for now");
    const [remove, result] = useDeleteIngredientCategoryMutation();

    return (
        <DataLoadingWardenForQuery query={ingredientCategories}>
            {() => (
                <>
                    <IonList className="menu-list-component">
                        {ingredientCategories.data.result.map((x) => (
                            <IonItem key={x.id}>
                                <IonLabel>{x.name}</IonLabel>
                                <RedirectActionButton
                                    text="Edytuj"
                                    to={`/dictionaries/ingredientCategories/update/${x.id}`}
                                    icon={pencilOutline}
                                />
                                <ActionWithConfirmation
                                    message={`Czy na pewno chcesz usunąć kategorię składnika ${x.name}?`}
                                    header="Usuwanie kategorii składnika"
                                    confirmedAction={() => remove({ id: x.id })}
                                />
                            </IonItem>
                        ))}
                    </IonList>
                    <IonFab
                        slot="fixed"
                        vertical="bottom"
                        horizontal="end"
                    >
                        <Link to="/dictionaries/ingredientCategories/add">
                            <IonFabButton>
                                <IonIcon icon={add}></IonIcon>
                            </IonFabButton>
                        </Link>
                    </IonFab>
                </>
            )}
        </DataLoadingWardenForQuery>
    );
};
